import { inject, bindable } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import {AuthService} from '../../services/authService';

@inject(Router, AuthService)
export class UserNavCustomElement {
  @bindable logout;
  @bindable accountActive;
  @bindable whitelabelActive;
  @bindable isAdmin;
  @bindable isYtmanager;
  @bindable isWladmin;
  @bindable isWlmanager;
  @bindable isWhitelabel;
  @bindable onNavigate;
  @bindable affiliateInfoLink;
  @bindable showAffiliateLink;
  @bindable showAffiliateLinkCode;
  @bindable captureKey;
  @bindable supportEmail;
  @bindable tutorialUrl;
  @bindable subscriptionType;
  @bindable enablePlus;
  @bindable isVendastaUser;

  constructor(router, api) {
    this.router = router;
    this.api = api;
    this.enable_white_label = false;
    this.url = this.api.getWhitelabel();
    console.log('sfdfsdf',this.url)
    if(this.url)
      this.isMagnfiWl = this.url.parent_id==0
    console.log('url',this.url)
    this.dashboardlength = 'col-sm-12';
    this.isdashboard = false;
    // console.log("start menu");
    // console.log(this.url.private_label);
    // console.log("end menu");

    if(this.url) {
          this.private_label = this.url.private_label;
          this.resource_url = this.url.parent_resource_url ?  this.url.parent_resource_url : "https://www.magnfi.com/agency-white-label-resources/";
          this.enable_white_label = this.url.enable_white_label_reseller ? this.url.enable_white_label_reseller : false;
    }
    else {
      this.resource_url = "https://www.magnfi.com/agency-white-label-resources/";
      this.private_label = false;
    }
  }

  attacted(){
    // console.log('ss1',this.isVendastaUser,'nn---------------------')
  }

  navigateLink(route, replace = false) {
    console.log("route param12300000",route);
    localStorage.setItem('rout', route);
    // if(route.includes("#/user/home") || route == "#/user" || route.includes("#/user/video/request")  || route.includes("#/user/video/caseStudy") || route.includes("#/user/video/email"))
    {
      this.isdashboard = true;
      this.dashboardlength = 'col-sm-12';
      console.log("Dashboard value is",this.isdashboard);
      // window.location.href = "Posts?Category=" + sel;
    }
    // else
    // {
    //   this.isdashboard = false;
    //   this.dashboardlength = 'col-sm-9';
    //   console.log("Dashboard value is",this.isdashboard);
    // }
    if(route.includes("#/user/video/email"))
    {
      if(route.includes("upload"))
      route = route + "?captureType=3" + "?videoUpload=1";
      else
      route = route + "?captureType=3";
      // window.location.href = "Posts?Category=" + sel;
    }

    if(route.includes("#/user/video/message"))
    {
      if(route.includes("upload"))
      route = route + "?captureType=5" + "?videoUpload=1";
      else
      route = route + "?captureType=5";
      // window.location.href = "Posts?Category=" + sel;
    }

    this.router.navigate(route, { replace: replace });
    this.onNavigate();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  createBrandedVideo() {
    this.navigateLink('#/user/videos');
    window.open(window.site_url+"#/capture/brand/"+this.captureKey, "_blank");

    // href.bind="'#/capture/brand/' + captureKey"

  }

  redirectToAdmin(){
    const user = JSON.parse(sessionStorage.getItem('magnfi_user'));
    window.location.href=`/admin-hub/sign-in?token=${user.token}&redirect_url=whitelabel-configuration/branding`
  }

  goToTutorials() {
    if(this.isWhitelabel) {
      window.open(this.tutorialUrl, '_blank');
    } else {
      this.navigateLink('#/user/tutorials');
    }

  }
}
